"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ShareGroup_exports = {};
__export(ShareGroup_exports, {
  default: () => ShareGroup_default
});
module.exports = __toCommonJS(ShareGroup_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.6172 7.73047H13.625C13.6901 7.92578 13.7422 8.1276 13.7812 8.33594C13.8203 8.53125 13.8398 8.73958 13.8398 8.96094C13.8398 9.52083 13.7096 10.0352 13.4492 10.5039C13.2018 10.9727 12.8633 11.3568 12.4336 11.6562H12.8633C13.2539 11.6562 13.625 11.7148 13.9766 11.832C14.3281 11.9362 14.6602 12.0859 14.9727 12.2812H17.668C17.7591 12.2812 17.8372 12.2422 17.9023 12.1641C17.9674 12.0859 18 11.9948 18 11.8906V10.3672C18 9.63802 17.7656 9.01953 17.2969 8.51172C16.8281 7.99089 16.2682 7.73047 15.6172 7.73047ZM10.4414 11.5C11.1445 11.5 11.7435 11.2526 12.2383 10.7578C12.7461 10.263 13 9.66406 13 8.96094C13 8.25781 12.7461 7.65885 12.2383 7.16406C11.7435 6.65625 11.1445 6.40234 10.4414 6.40234C9.73828 6.40234 9.13281 6.65625 8.625 7.16406C8.13021 7.65885 7.88281 8.25781 7.88281 8.96094C7.88281 9.66406 8.13021 10.263 8.625 10.7578C9.13281 11.2526 9.73828 11.5 10.4414 11.5ZM5.36328 16.9102C5.27214 16.9102 5.19401 16.8776 5.12891 16.8125C5.0638 16.7474 5.03125 16.6693 5.03125 16.5781V15.3672C5.03125 14.5339 5.33724 13.8242 5.94922 13.2383C6.5612 12.6523 7.29688 12.3594 8.15625 12.3594H12.7656C13.638 12.3594 14.3802 12.6523 14.9922 13.2383C15.6042 13.8242 15.9102 14.5339 15.9102 15.3672V16.5781C15.9102 16.6693 15.8776 16.7474 15.8125 16.8125C15.7474 16.8776 15.6693 16.9102 15.5781 16.9102H5.36328ZM7.14062 6.85156C7.70052 6.85156 8.17578 6.64974 8.56641 6.24609C8.97005 5.84245 9.17188 5.36068 9.17188 4.80078C9.17188 4.22786 8.97005 3.74609 8.56641 3.35547C8.17578 2.95182 7.70052 2.75 7.14062 2.75C6.56771 2.75 6.07943 2.95182 5.67578 3.35547C5.28516 3.74609 5.08984 4.22786 5.08984 4.80078C5.08984 5.36068 5.28516 5.84245 5.67578 6.24609C6.07943 6.64974 6.56771 6.85156 7.14062 6.85156ZM13.8398 6.85156C14.3997 6.85156 14.875 6.64974 15.2656 6.24609C15.6693 5.84245 15.8711 5.36068 15.8711 4.80078C15.8711 4.22786 15.6693 3.74609 15.2656 3.35547C14.875 2.95182 14.3997 2.75 13.8398 2.75C13.2669 2.75 12.7786 2.95182 12.375 3.35547C11.9844 3.74609 11.7891 4.22786 11.7891 4.80078C11.7891 5.36068 11.9844 5.84245 12.375 6.24609C12.7786 6.64974 13.2669 6.85156 13.8398 6.85156ZM8.07812 11.6562H8.44922C8.01953 11.3568 7.67448 10.9727 7.41406 10.5039C7.16667 10.0352 7.04297 9.52083 7.04297 8.96094C7.04297 8.73958 7.0625 8.53125 7.10156 8.33594C7.14062 8.1276 7.19922 7.92578 7.27734 7.73047H5.38281C4.73177 7.73047 4.17188 7.99089 3.70312 8.51172C3.23438 9.01953 3 9.63802 3 10.3672V11.8906C3 11.9948 3.03255 12.0859 3.09766 12.1641C3.16276 12.2422 3.24089 12.2812 3.33203 12.2812H5.96875C6.26823 12.0859 6.59375 11.9362 6.94531 11.832C7.3099 11.7148 7.6875 11.6562 8.07812 11.6562Z",
      fill: "currentColor"
    }
  )
);
const SvgShareGroup = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ShareGroup_default = SvgShareGroup;
